import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const TransferAction = {
    /**
     * 确认调拨
     * @param data
     */
    submitTransfer(data={}) {
        return request({
            url:  '/service/mg/allocate/submit',
            method: "POST",
            data
        });
    },
    /**
     * 获取单个出库详情
     * @param data
     */
    postDeliveryListInfo(data={}) {
        return request({
            url: '/service/mg/delivery-management/delivery-list-info',
            method: "POST",
            data
        });
    },
    /**
     * 移到待出库
     * @param data
     */
    postBatchAllocate(data={}) {
        return request({
            url: '/service/mg/allocate/cancel',
            method: "POST",
            data
        });
    },
    /**
     *撤消
     * @param data
     */
    rollback(data={}) {
        return request({
            url: '/service/mg/allocate/rollback',
            method: "POST",
            data
        });
    },
    /**
     * 调拨入
     * @param data
     */
    inStorage(data={}) {
        return request({
            url: '/service/mg/allocate/in-storage',
            method: "POST",
            data
        });
    },
};

export default TransferAction;
